// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"3e06e445","748":"c33fb688","787":"c84b9766"}[chunkId] + ".chunk.js";
};